"use client";

import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ImagerySection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235741" id="ossariodelpasubio" className="bg-background text-foreground py-12 md:py-20 lg:py-28">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="relative group">
            <AspectRatio ratio={16 / 7} className="bg-muted rounded-none overflow-hidden shadow-4xl border border-border/20">
              <img src="https://sacropan.it/wp-content/uploads/2026/04/ossarrio-pasubio.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/ossarrio pasubio.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1648136/img/ossarrio pasubio.png-wvc-sizes" alt="L'Ossario del Pasubio in un'atmosfera solenne" className="object-contain w-full h-full grayscale contrast-125 scale-105 transition-transform duration-700 group-hover:scale-110" loading="lazy" decoding="async" />
            </AspectRatio>
            
            <div className="absolute inset-0 flex items-center justify-start pl-8 md:pl-16 pointer-events-none">
              <div className="max-w-md p-8 bg-card/80 backdrop-blur-md rounded-lg border border-border/30 text-center shadow-2xl pointer-events-auto">
                <h2 className="text-3xl md:text-4xl font-default mb-4 tracking-wider text-foreground">Ossario del Pasubio</h2>
                <p className="text-sm md:text-base font-default leading-relaxed text-muted-foreground">Pietra e silenzio a veglia sulla storia, dove l’eco del passato onora chi cadde per queste montagne.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}